import { jsxs, jsx } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material";
const MinusCircle = createSvgIcon(
  /* @__PURE__ */ jsxs("svg", { width: "26", height: "27", viewBox: "0 0 26 27", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
    /* @__PURE__ */ jsxs("g", { filter: "url(#filter0_dd_5603_84080)", children: [
      /* @__PURE__ */ jsx("rect", { x: "1", y: "1", width: "24", height: "24", rx: "12", fill: "#F5F5F5", shapeRendering: "crispEdges" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M7.75 12.9998C7.75 12.6778 8.01133 12.4165 8.33333 12.4165H17.6667C17.9887 12.4165 18.25 12.6778 18.25 12.9998C18.25 13.3218 17.9887 13.5832 17.6667 13.5832H8.33333C8.01133 13.5832 7.75 13.3218 7.75 12.9998Z",
          fill: "black"
        }
      )
    ] }),
    /* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsxs(
      "filter",
      {
        id: "filter0_dd_5603_84080",
        x: "0",
        y: "0",
        width: "26",
        height: "26.5",
        filterUnits: "userSpaceOnUse",
        colorInterpolationFilters: "sRGB",
        children: [
          /* @__PURE__ */ jsx("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
          /* @__PURE__ */ jsx(
            "feColorMatrix",
            {
              in: "SourceAlpha",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }
          ),
          /* @__PURE__ */ jsx("feOffset", { dy: "0.5" }),
          /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: "0.5" }),
          /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
          /* @__PURE__ */ jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.35 0" }),
          /* @__PURE__ */ jsx("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow_5603_84080" }),
          /* @__PURE__ */ jsx(
            "feColorMatrix",
            {
              in: "SourceAlpha",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }
          ),
          /* @__PURE__ */ jsx("feOffset", { dy: "-0.5" }),
          /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: "0.25" }),
          /* @__PURE__ */ jsx("feComposite", { in2: "hardAlpha", operator: "out" }),
          /* @__PURE__ */ jsx("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
          /* @__PURE__ */ jsx("feBlend", { mode: "normal", in2: "effect1_dropShadow_5603_84080", result: "effect2_dropShadow_5603_84080" }),
          /* @__PURE__ */ jsx("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect2_dropShadow_5603_84080", result: "shape" })
        ]
      }
    ) })
  ] }),
  "MinusCircle"
);
export {
  MinusCircle as default
};
